export const EVENTS_NAMESPACE = 'wix.events.v3.event';
//# sourceMappingURL=namespace.js.map